<div class="relative">
  <app-notification-dialog
    [isOpen]="isNotificationOpen()"
    [showDateRange]="true"
    title="Notifica generale"
    description="Invia un annuncio breve a tutti gli utenti in un'unica volta."
    submitLabel="Invia notifica"
    (closeDialog)="closeNotification()"
    (submitForm)="sendGlobalNotification($event)"
  />

  <button
    type="button"
    (click)="toggleProfileMenu()"
    class="flex items-center gap-3 cursor-pointer rounded-full border border-gray-200 py-1.5 pl-1.5 pr-3 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:hover:bg-gray-800"
    aria-label="User menu"
    [attr.aria-expanded]="isProfileMenuOpen()"
  >
    <div
      class="h-8 w-8 rounded-full object-cover bg-blue-500 flex items-center justify-center text-white"
    >
      {{ initials() }}
    </div>
    <span class="hidden text-sm font-medium text-gray-700 dark:text-gray-300 lg:block">{{
      firstName()
    }}</span>
    <svg
      class="h-4 w-4 text-gray-400 transition-transform"
      [class.rotate-180]="isProfileMenuOpen()"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Profile Dropdown Menu -->
  @if (isProfileMenuOpen()) {
    <div
      class="absolute right-0 top-14 w-64 rounded-xl border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
    >
      <div class="border-b border-gray-200 px-4 py-3 dark:border-gray-700">
        <p class="text-sm font-normal text-gray-900 dark:text-white">{{ userName() }}</p>
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ userEmail() }}</p>
      </div>
      <nav class="p-2">
        @for (item of visibleItems(); track item.label) {
          @switch (item.type) {
            @case ('separator') {
              <div class="border-t border-gray-200 my-2 dark:border-gray-700"></div>
            }
            @case ('link') {
              @if (item.target === '_blank') {
                <a
                  [href]="item.route"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="closeMenus()"
                  class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                  <svg
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      [attr.d]="item.iconPath"
                    />
                  </svg>
                  {{ item.label }}
                </a>
              } @else {
                <a
                  [routerLink]="item.route"
                  (click)="closeMenus()"
                  class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                  <svg
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      [attr.d]="item.iconPath"
                    />
                  </svg>
                  {{ item.label }}
                </a>
              }
            }
            @case ('button') {
              <button
                type="button"
                [class]="
                  item.isLogout
                    ? 'flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2 text-sm text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20'
                    : 'flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                "
                (click)="handleMenuItemClick(item)"
              >
                <svg
                  class="h-5 w-5"
                  [class.text-gray-400]="!item.isLogout"
                  [class.text-red-600]="item.isLogout"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    [attr.d]="item.iconPath"
                  />
                </svg>
                {{ item.label }}
              </button>
            }
          }
        }
      </nav>
    </div>
  }
</div>
